import {
	AfterViewInit,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
}                                   from '@angular/core';
import { FormControlBaseComponent } from '@app/core/bases/form-control-base/form-control-base.component';
import { UiSwitchSizeEnum }         from '@app/core/interfaces/form.interface';
import { delay }                    from 'rxjs/operators';

@Component( {
	selector: 'app-form-switch[formEntityId][formGroup][config]',
	templateUrl: './form-switch.component.html',
	styleUrls: [ './form-switch.component.scss' ]
} )
export class FormSwitchComponent extends FormControlBaseComponent implements AfterViewInit, OnInit {

	@Input() isChecked: boolean;

	@Input() size: UiSwitchSizeEnum;

	@Output() changeEmitter = new EventEmitter<boolean>();

	revertValue: boolean;

	constructor() {
		super();
	}

	protected updateRevertValue( val: boolean ) {
		if ( val ) { this.revertValue = val; }
	}

	ngOnInit() {
		super.ngOnInit();

		this.size = this.size ? this.size : UiSwitchSizeEnum.MEDIUM;

		this.control?.valueChanges
		.pipe( delay( 0 ) )
		.subscribe( val => {
			this.updateActionButtonsVisibility( !!val );
			this.updateRevertValue( val );
		} );
	}

	ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}

	onChange( state: boolean ) {
		this.changeEmitter.emit( state );
	}
}
